import { queryClient } from '@src/routers/constants';

export const SEMANTIC_MAPPER = 'Semantic Mapper';

export const trackGetEventsInLiveLens = (data: any) => {
  trackCustomEvent('Get Events in Live Lens', data);
};
export const trackClickClientIdInLiveLens = (data: any) => {
  trackCustomEvent('Click ClientId in Live Lens', data);
};
export const trackLeftLiveLens = (data: any) => {
  trackCustomEvent('Left Live Lens', data);
};
export const trackOptionsInLiveLens = (data: any) => {
  trackCustomEvent('Options in Live Lens', data);
};
export const trackBackToLiveLens = (data: any) => {
  trackCustomEvent('Back to Live Lens', data);
};

export const trackMapNewEvent = (data: any) => {
  trackCustomEvent('Map New Event', data);
};
export const trackUpdateMappedEvent = (data: any) => {
  trackCustomEvent('Update Mapped Event', data);
};
export const trackClickMapNewEvent = (data: any) => {
  trackCustomEvent('Click Map New Event', data);
};
export const trackClickEditMappedEvent = (data: any) => {
  trackCustomEvent('Click Edit Mapped Event', data);
};
export const trackNewCustomDimension = (data: any) => {
  trackCustomEvent('Open Custom Dimension', data);
};
export const trackErrorInEMP = (data: any) => {
  trackCustomEvent('Error in EMP', data);
};
export const trackErrorInEMPInTrends = (data: any) => {
  trackCustomEvent('Error in EMP in Trends', data);
};
export const trackActivateMetrics = (data: any) => {
  trackCustomEvent('Activate Metrics', data);
};
export const trackDimensionOperation = (data: any) => {
  trackCustomEvent('Dimension Operation ', data);
};
export const trackQueryInfo = (data: any) => {
  trackCustomEvent('Query Info', data);
};
export const trackManagementTabsClick = (data: any) => {
  trackCustomEvent('Click Management Tabs', data);
};
export const trackViewinSemanticClick = (data: any) => {
  trackCustomEvent('Click View in Semantic Mapper', data);
};
export const trackGenerateSankey = (data: any) => {
  trackCustomEvent('Generate Sankey', data);
};
export const trackGenerateSankeySuccess = (data: any) => {
  trackCustomEvent('Generate Sankey Success', data);
};
export const trackGenerateSankeyFailure = (data: any) => {
  trackCustomEvent('Generate Sankey Failure', data);
};
export const trackViewInFunnelClick = (data: any) => {
  trackCustomEvent('Click View In Funnel Button', data);
};
export const trackViewUserTimelineFromSankey = (data: any) => {
  trackCustomEvent('View User Timeline From Sankey', data);
};
export const trackGenerateFunnel = (data: any) => {
  trackCustomEvent('Generate Funnel', data);
};
export const trackGenerateFunnelSuccess = (data: any) => {
  trackCustomEvent('Generate Funnel Success', data);
};
export const trackGenerateFunnelFailure = (data: any) => {
  trackCustomEvent('Generate Funnel Failure', data);
};
export const trackSankeyShare = (data: any) => {
  trackCustomEvent('Click Sankey Share Button', data);
};
export const trackFunnelShare = (data: any) => {
  trackCustomEvent('Click Funnel Share Button', data);
};
export const trackViewUserTimelineFromFunnel = (data: any) => {
  trackCustomEvent('View User Timeline From Funnel', data);
};

interface WorkflowTrackData {
  type: 'dimension' | 'metric' | 'flow' | 'rename';
  operation: 'create' | 'edit';
  error?: string;
  id?: number;
}

// ---- new workflow ----
export const trackClickWorkflowSave = (data: WorkflowTrackData) => {
  trackCustomEvent('Click save in new workflow', data);
};

export const trackClickDeploy = (data: any) => {
  trackCustomEvent('Click deploy', data);
};

export const trackClickDeployWorkbench = (data: any) => {
  trackCustomEvent('Click deploy workbench', data);
};

// ---- end new workflow ----

// ---- management ----
export const trackClickBulkActionManagement = (data: any) => {
  trackCustomEvent('Click bulk action in management', data);
};
// ---- end management ----

export const trackPageLoadTime = (pageName: string) => {
  const startTime = new Date().getTime();
  let endTime = new Date().getTime();
  const timer = setInterval(() => {
    const isFetching = queryClient.isFetching();
    // isFetching is a counter, so we need to check if it's 0 to know if all queries are done
    if (isFetching === 0) {
      endTime = new Date().getTime();
      const duration = endTime - startTime;
      if (duration) {
        trackCustomEvent('Page load time', { duration });
      }
      trackCustomEvent('Total page load time', { url: window.location.href });
      clearInterval(timer);
    }
  }, 200);
};

export const trackCustomEvent = (name: string, data: any) => {
  data = {
    ...data,
    timestamp: new Date().getTime(),
  };
  const event = new CustomEvent('trackCustomEvent', {
    detail: {
      name,
      data: data,
    },
  });
  document.dispatchEvent(event);
};
